const locale = {
	// #region Recycle bin fields
	RECYCLEBIN_COLUMN_TABLE: 'Tipo elemento',
	RECYCLEBIN_COLUMN_TABLE_TITLE: 'Elemento',
	RECYCLEBIN_COLUMN_USER: 'Utente',
	RECYCLEBIN_COLUMN_DATE: 'Data'
	// #endregion
};

export default locale;
